export default __webpack_public_path__ + "media/portrait/logo_adobe-78cd5405.svg";